import React from 'react'
import { Box, Flex } from '@chakra-ui/core'
import ContextDisplay from 'components/ContextDisplay'
import { notifTokens } from 'services/notifications/designTokens'
import { IServiceVisual } from 'services/notifications/serviceVisuals'

const ICON_SIZE = '52px'
const BADGE_SIZE = '31px'
const SERVICE_ICON_SIZE = 18

interface IProps {
  visual: IServiceVisual
  isUnread: boolean
  senderId?: string
  isRtl?: boolean
}

// Sender avatar with the service icon overlaid on its corner (mirrored for RTL) — shared by
// NotificationRow (Notification Center list/desktop modal) and PushToastCard (browser push toast)
// so the two surfaces can't drift out of sync in size again like they just did.
export const NotificationServiceIcon: React.FC<IProps> = ({ visual, isUnread, senderId, isRtl = false }) => (
  <Box position="relative" flexShrink={0}>
    {senderId && (
      <Box
        borderRadius="999px"
        boxShadow="0 2px 7px rgba(15,23,42,.12)"
        opacity={isUnread ? 1 : 0.45}
      >
        <ContextDisplay
          contextId={senderId}
          showContextName={false}
          avatarProps={{ width: ICON_SIZE, height: ICON_SIZE }}
          containerProps={{ style: { gap: '0' } }}
        />
      </Box>
    )}
    {!senderId && (
      <Flex
        alignItems="center"
        justifyContent="center"
        borderRadius="999px"
        bg={isUnread ? visual.soft : '#EEF2F7'}
        color={isUnread ? visual.text : notifTokens.muted}
        minW={ICON_SIZE}
        h={ICON_SIZE}
      >
        {React.cloneElement(visual.icon as React.ReactElement, { size: 22 })}
      </Flex>
    )}
    {senderId && (
      <Flex
        alignItems="center"
        justifyContent="center"
        position="absolute"
        bottom="-4px"
        right={isRtl ? undefined : '-8px'}
        left={isRtl ? '-8px' : undefined}
        borderRadius="999px"
        border="2px solid white"
        boxShadow="0 2px 5px rgba(15,23,42,.18)"
        bg={isUnread ? visual.soft : '#EEF2F7'}
        color={isUnread ? visual.text : notifTokens.muted}
        minW={BADGE_SIZE}
        h={BADGE_SIZE}
      >
        {React.cloneElement(visual.icon as React.ReactElement, { size: SERVICE_ICON_SIZE })}
      </Flex>
    )}
  </Box>
)
